import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import VueAnalytics from 'vue-analytics'
Vue.use(Router)

export default new Router({
  routes,
  mode: 'history',
  base: __dirname,
})



Vue.use(VueAnalytics, {
  id: 'UA-141573050-1',
  debug: {
    enabled: false, // default value
    trace: true, // default value
    sendHitTask: true // default value
  },
  Router
})


// WEBPACK FOOTER //
// ./src/router/index.js